import React from "react";
import { Box, Typography } from "@mui/material";

import { PageTitle } from "@components/common";

const EnginesPage: React.FC = () => {
  return (
    <Box mb={6}>
      <Box mb={3}>
        <PageTitle title="Organization" />
        <Typography variant="h1"></Typography>
      </Box>
      <Box mb={3}></Box>
    </Box>
  );
};

export default EnginesPage;
